module.exports = __webpack_public_path__ + "static/media/thumbnail.99799ab5.jpg";